export default __webpack_public_path__ + "static/media/vuesax-linear-calendar-search.fa385690.svg";